import { render, staticRenderFns } from "./InquiryRequestDetails.vue?vue&type=template&id=46c8882e&scoped=true"
import script from "./InquiryRequestDetails.vue?vue&type=script&lang=ts"
export * from "./InquiryRequestDetails.vue?vue&type=script&lang=ts"
import style0 from "./InquiryRequestDetails.vue?vue&type=style&index=0&id=46c8882e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c8882e",
  null
  
)

export default component.exports